export default __webpack_public_path__ + "50b4870811918e52390ed60762b2dd78.png";